import React, { Component, useState } from 'react'
import { IProps } from './component';

// export const Otp = () => {
//     return (
//         <div>
//             <h1>Otp Component</h1>
//         </div>
//     )
// }

import { Form, Button, Input, Select, Icon } from 'antd'
// import { JSONProps } from "./antd.interface";
// import { connect } from "react-redux";
// import axios from 'axios';
// import { store } from "../../store";

// import style from './otp.module.sass'

// @ts-ignore
import OtpInput from "react-otp-input";
import { logger } from '../../../../../../constant/winston';
// import './otp.css'
// import './otp.module.sass';


const { Option } = Select;
const InputGroup = Input.Group;


// interface Iporps extends JSONProps {
//   updateValue: (value: any, update: string, variable?: any) => void;
//   asyncValidation: boolean;
//   taskInfo: any

// }


export const Otp = (props: IProps) => {

    let [state, setstate] = useState({
        phnumber: "",
        isButtonLoading: false, showSuccesIcon: false,
        showFailureIcon: false,
        buttonLabel: "Send OTP",
        sendButtonLoading: false,
        otpPinId: "",
        otpValue: "",
        phValid: "",
        otpsubmitbtnloading: false
    })

    // const renderButtonContent = (showSuccesIcon: boolean, showFailureIcon: boolean, buttonLabel: string) => {

    //     let button: JSX.Element;
    //     if (showSuccesIcon) {
    //         button = (
    //             <div className='buttonCentered'>
    //                 <Icon
    //                     type="check-circle"
    //                     theme="twoTone"
    //                     twoToneColor="#52c41a"
    //                 />
    //                 <span>
    //                     {buttonLabel}
    //                 </span>
    //             </div>
    //         );
    //     } else if (showFailureIcon) {
    //         button = (
    //             <div className='buttonCentered'>
    //                 <Icon
    //                     type="close-circle"
    //                     theme="twoTone"
    //                     twoToneColor="#cb1e1a"
    //                 />
    //                 <span>
    //                     {buttonLabel}
    //                 </span>
    //             </div>
    //         );
    //     } else {
    //         button = <div className='buttonCentered'>{buttonLabel}</div>;
    //     }

    //     return button;
    // }


    // const handleSendApi = () => {

    //     let { phnumber } = state

    //     if (phnumber.length === 10) {
    //         //   let authToken = props.taskInfo.authToken ? props.taskInfo.authToken : null;
    //         //   let config: any = {
    //         //     method: 'post',
    //         //     url: `${'https://esaf-testing.autonom8.com/service-app/apis'}/v1/sendOtp`,
    //         //     headers: {
    //         //       Authorization: authToken
    //         //     },
    //         //     data: {
    //         //       mobile: "91" + phnumber
    //         //     }
    //         //   };
    //         // this.setState({ c2loading: true });
    //         setstate((prev) => { return { ...prev, sendButtonLoading: true } })
    //         //   axios(config).then(
    //         //     response => {
    //         //       var pinId = response.data.pinId;
    //         //       if (response.data.smsStatus === "MESSAGE_SENT") {
    //         //         let OTP_Status = response.data.smsStatus;
    //         //         // updateValue()
    //         //         let otpstatus = {
    //         //           type: "String",
    //         //           value: OTP_Status
    //         //         }
    //         //         props.updateValue(otpstatus, "change", `${props.bind}_OTP_STATUS`);
    //         //         let phNumber = {
    //         //           type: "String",
    //         //           value: phnumber
    //         //         }
    //         //         props.updateValue(phNumber, "change", `${props.bind}_OTP_phNumber`);
    //         //         // this.props.fieldPopulator("c2OTP_Status", { type: "String", value: OTP_Status });
    //         //       }
    //         //       setstate((prev) => {
    //         //         return { ...prev, otpPinId: pinId, sendButtonLoading: false, buttonLabel: "RESEND OTP", showSuccesIcon: true, showFailureIcon: false }
    //         //       }
    //         //       )

    //         //     }
    //         //   ).catch((err: any) => {
    //         //     setstate((prev) => {
    //         //       return { ...prev, sendButtonLoading: false, showFailureIcon: true, buttonLabel: "RESEND OTP", showSuccesIcon: false }
    //         //     })
    //         //   })
    //     } else {
    //         setstate({ ...state, phValid: "Invalid Ph Number", showFailureIcon: true })
    //     }
    // };

    // const handleResendApi = () => {
    //     // let authToken = props.taskInfo.authToken ? props.taskInfo.authToken : null;

    //     // let config: any = {
    //     //   url: `${'https://esaf-testing.autonom8.com/service-app/apis'}/v1/resendOtp`,
    //     //   method: "post",
    //     //   headers: {
    //     //     Authorization: authToken
    //     //   },
    //     //   data: {
    //     //     pin_id: state.otpPinId
    //     //   }
    //     // };

    //     setstate((prev) => { return { ...prev, sendButtonLoading: true } })

    //     // axios(config).then(
    //     //   response => {
    //     //     let resendpinID = response.data.pinId;

    //     //     // this.setState({
    //     //     //   c2otpPinID: resendpinID,
    //     //     //   c2otpSent: true,
    //     //     //   c2loading: false,
    //     //     //   c2buttonLabel: "RESEND OTP",
    //     //     //   c2showSuccess: true
    //     //     // });
    //     //     setstate((prev) => {
    //     //       return { ...prev, otpPinId: resendpinID, sendButtonLoading: false, buttonLabel: "RESEND OTP", showSuccesIcon: true }
    //     //     }
    //     //     )
    //     //   },
    //     //   () => {
    //     //     setstate((prev) => {
    //     //       return { ...prev, sendButtonLoading: false, buttonLabel: "RESEND OTP", showSuccesIcon: false, showFailureIcon: true }
    //     //     }
    //     //     )
    //     //   }
    //     // );
    // };

    const handleOtpNumber = (otp: string) => {

        try {
            logger.debug(otp);
        } catch (error) {
            setstate((prev) => {
                return { ...prev, showFailureIcon: true, buttonLabel: "RESEND OTP", showSuccesIcon: false, otpsubmitbtnloading: false }
            });
        }
    };


    const properties = props.json.properties;
    return (
        <div>
            <Form.Item
                className={'override-common'}
                label={properties.label}
            >
                <InputGroup compact className='override-otp'>
                    <Select
                        data-test-id="select"
                        defaultValue="91"
                        dropdownClassName='select-dropdown'
                    // disabled={disableSubmit}
                    >
                        {["91"].map((value, key) =>
                            <Option data-test-id={`options_${value}`} key={key} value={value}>{value}</Option>
                        )}
                    </Select>
                    <Input
                        data-test-id="phone_number"
                        //   disabled={disableSubmit}
                        value={state.phnumber}
                        // className={`otp-ph-input ${state.phValid && "ph-error"}`} 
                        placeholder="Phone Number"
                        onChange={(e: any) => {
                            if (!isNaN(e.target.value)) {
                                setstate({ ...state, phnumber: e.target.value, buttonLabel: "Send OTP", showFailureIcon: false, showSuccesIcon: false, phValid: "" })
                            }
                        }}
                    />
                    <Button
                        data-test-id="send_btn"
                        type='primary'
                    // disabled={disableSubmit}
                    // onClick={state.buttonLabel === "Send OTP" ? handleSendApi : handleResendApi}
                    >
                        {state.sendButtonLoading ? (
                            <div className='buttonCentered'>
                                <Icon type="loading" spin />
                            </div>
                        ) : (
                            <div className='buttonCentered'>{state.buttonLabel}</div>
                            // renderButtonContent(
                            //     state.showSuccesIcon,
                            //     state.showFailureIcon,
                            //     state.buttonLabel
                            // )
                        )}
                    </Button>
                </InputGroup>
            </Form.Item>

            <p style={{ color: "#cb1e1a" }}>{state.phValid}</p>
            {
                <OtpBox
                    data-test-id="submit_btn"
                    numInputs={4}
                    submitLabel={"submit"}
                    //   disableSubmit={disableSubmit}
                    mobileNumber={
                        state.phnumber
                    }
                    //   value={value}
                    handleOtpNumber={handleOtpNumber}
                    otpOnchange={() => {

                    }}
                    buttonloading={state.otpsubmitbtnloading}
                    className=""
                />
            }
        </div>
    )

}



type Iprops = {
    numInputs: number;
    mobileNumber?: string;
    disableSubmit?: boolean;
    handleOtpNumber?: any;
    submitLabel?: string;
    otpOnchange?: any;
    Email?: string;
    value?: string;
    className: string
    buttonloading?: boolean
};
type Istate = {
    otp: string;
    isDisabled: boolean;
    hasErrored: boolean;
    isInputNum: boolean;
    renderTime: any;
};

class OtpBox extends Component<Iprops, Istate> {
    constructor(props: any) {
        super(props);
        this.state = {
            otp: props.value || "",
            isDisabled: false,
            hasErrored: false,
            isInputNum: false,
            renderTime: ""
        };
    }

    handleOtpChange = (otp: any) => {
        this.setState({ otp });
        // this.props.otpOnchange(otp);
    };
    clearOtp = () => {
        this.setState({ otp: "", renderTime: Date.now() });
    };
    render() {
        const {
            otp,
            // isDisabled,
            // hasErrored,
            renderTime,
            isInputNum
        } = this.state;

        let {
            numInputs,
            // mobileNumber,
            disableSubmit,
            handleOtpNumber,
            submitLabel,
            // Email
        } = this.props;

        return (
            // <div className="Otp-wrapper">
            <div className="override-common">
                {/* <p className='otp-message'>
                    Enter the {numInputs} digit One Time Password (OTP) sent to {Email ? Email : mobileNumber}
                </p> */}
                <label className='otp-message'>ENTER OTP</label>

                <div className="form-otp">
                    <OtpInput
                        data-test-id="otp_input"
                        inputStyle="otp-input"
                        containerStyle="container_style"
                        numInputs={numInputs}
                        isDisabled={disableSubmit}
                        onChange={this.handleOtpChange}
                        separator={false}
                        isInputNum={isInputNum}
                        shouldAutoFocus={false}
                        // hasErrored={true}
                        value={otp}
                        key={renderTime}
                    />
                </div>
                {/* form-group col-xs-12  */}
                <div className="otp-common-button">
                    <ul className="list-inline otp-button">
                        <li style={{ marginLeft: "0px" }}>
                            <Button
                                data-test-id="clear_otp"
                                // className="button button-primary button-sm"
                                // type="button"
                                type="primary"
                                onClick={this.clearOtp}
                                disabled={disableSubmit}
                            >
                                CLEAR
                            </Button>
                        </li>
                        <li>
                            <Button
                                data-test-id="submit_otp"
                                // type="button"
                                type="primary"
                                onClick={handleOtpNumber.bind(this, otp, this.clearOtp)}
                                // className="button button-primary button-primary-alt button-sm"
                                disabled={otp.length < numInputs || disableSubmit}
                                loading={this.props.buttonloading}
                            >
                                {submitLabel && submitLabel.toUpperCase()}
                            </Button>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}
